export function enterTerminal() {
  const prefetch = document.createElement("link")
  prefetch.rel = "prefetch"
  prefetch.href = "/app/index.html"
  document.head.appendChild(prefetch)
  window.dispatchEvent(new CustomEvent("verus:enter-terminal"))
  window.setTimeout(() => {
    window.location.href = "/app/"
  }, 640)
}
